import { styled } from "@mui/material/styles";
import { Grid, Collapse } from "@mui/material";
import { SPACING } from "src/_globalStore/redux/reducers/Theme/themeConstants";
import { Link } from "react-router-dom";

export const Root = styled(Grid)(({ theme }) => ({
  width: "100vw",
  height: "100vh",
  maxWidth: "100vw",
  maxHeight: "100vh",
  overflow: "hidden",
}));

export const Container = styled(Grid)((theme) => ({
  width: "100%",
  height: `calc(100% - ${SPACING[9]}px)`,
  display: "flex",
  padding: `
    ${SPACING[9]}px 
    ${SPACING[9]}px
    0px
    ${SPACING[9]}px
  `,
  // backgroundColor:"blue",
}));

export const HeaderContainer = styled(Grid)(({ theme }) => ({
  display: "flex",
  // flexDirection: "row-reverse",
  justifyContent: "space-between",
  // height: "70px",
  minHeight: "70px",
  maxHeight: "120px",
  marginBottom: `${SPACING[7]}px`,
}));

export const HeaderAndContentContainer = styled(Grid)({
  maxWidth: "100%",
  overflow: "hidden",
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  paddingLeft: `${SPACING[3]}px`, //10
});

export const ContentContainer = styled(Grid)({
  // backgroundColor: "red",
  height: `calc(100% - 70px)`,
  width: "100%",
  overflow: "auto",
});

export const Content = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "showBackdrop",
})<{ showBackdrop: boolean }>(
  {
    transition: "all .6s ease",
  },
  ({ showBackdrop }) => ({
    ...(showBackdrop && {
      backgroundColor: "rgba(0, 0, 0, .1)",
    }),
  })
);

export const DisclaimerContainer = styled(Grid)(({ theme }) => ({
  gap: "10px",
  height: "24px",
  padding: "0px 26px",
  color: theme.palette.text.secondary,
  display: "flex",
  "& a": {
    textDecoration: "none",
    fontWeight: 600,
    color: theme.palette.text.secondary,
  },
}));

export const LoginLink = styled(Link)(({ theme }) => ({
  color: theme.palette.text.primary,
  width: "min-content",
  alignSelf: "center",
  height: "20px",
}));
